var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 3.375H3.75a.376.376 0 0 0-.375.375v7.125c0 .206.169.375.375.375h7.125a.376.376 0 0 0 .375-.375V3.75a.376.376 0 0 0-.375-.375ZM9.656 9.656H4.97V4.97h4.687v4.687ZM20.25 3.375h-7.125a.376.376 0 0 0-.375.375v7.125c0 .206.169.375.375.375h7.125a.376.376 0 0 0 .375-.375V3.75a.376.376 0 0 0-.375-.375Zm-1.219 6.281h-4.687V4.97h4.687v4.687Zm-8.156 3.094H3.75a.376.376 0 0 0-.375.375v7.125c0 .206.169.375.375.375h7.125a.376.376 0 0 0 .375-.375v-7.125a.376.376 0 0 0-.375-.375Zm-1.219 6.281H4.97v-4.687h4.687v4.687ZM20.25 12.75h-7.125a.376.376 0 0 0-.375.375v7.125c0 .206.169.375.375.375h7.125a.376.376 0 0 0 .375-.375v-7.125a.376.376 0 0 0-.375-.375Zm-1.219 6.281h-4.687v-4.687h4.687v4.687Z"
  })));
};

export default SvgDashboard;